<script setup lang="ts">
// PROPS
import type { PlatformSaleItemEntity } from '~/types/sale.type';

interface Props {
    sale: PlatformSaleItemEntity;
}
const { sale } = defineProps<Props>();

// COMPOSABLES
const { isTrustReportEligible } = useTrustReport(() => sale);
const { tt } = useTypedI18n();
</script>

<template>
    <UBadge
        v-if="isTrustReportEligible"
        color="success"
        variant="subtle"
        :label="`${tt('sdp.trustReport.inspectedBy')} Fleequid`"
        icon="lucide:shield-check"
        class="text-inverted bg-green-700"
    />
</template>
